import {GET_DAILY} from '../Actions/types'

const initialState= { 
    hoursInDay: "",

}

export default function (state = initialState, action) {

        switch(action.type) {
            case GET_DAILY: 
                return{
                    ...state,
                    hoursInDay: action.payload
                };
                default: 
            return state;

        }
    }



// WEBPACK FOOTER //
// ./src/Reducers/DailyChartReducer.js